module.exports = __webpack_public_path__ + "static/img/cyberpuertaFullWeb.167874e7.webp";